import { useMutation } from "@tanstack/react-query"
import { getErrorCode } from "@krakentech/blueprint-api"
import { throwKrakenErrorResponse } from "@krakentech/error-intl"
import { ERROR_CODE } from "@/constants/errorCode"
import { CheckMeterPointEligibilitySchema } from "@/features/meter-points/schemas/checkMeterPointsEligibilitySchema"
import { apiRoutesPaths } from "@/routes/api"
import { type CheckMeterPointsEligibilityInput } from "../handlers/checkMeterPointEligibilityHandler"

export function useCheckMeterPointEligibility() {
    return useMutation({
        mutationKey: ["CheckMeterPointsEligibilityMutation"],
        mutationFn: async (input: CheckMeterPointsEligibilityInput) => {
            const headers = new Headers({ "Content-Type": "application/json" })

            const response = await fetch(apiRoutesPaths.checkMeterPointEligibility.resolve(), {
                method: "POST",
                body: JSON.stringify(input),
                headers,
            })

            if (!response.ok) {
                throw new Error(JSON.stringify(response))
            }

            const jsonResponse = await response.json()

            const errorCode = getErrorCode({ response: jsonResponse })

            if (errorCode) {
                throwKrakenErrorResponse({ errorCode })
            }

            try {
                return CheckMeterPointEligibilitySchema.parse(jsonResponse)
                    .checkMeterPointsEligibility
            } catch {
                throwKrakenErrorResponse({ errorCode: ERROR_CODE.UNKNOWN_METER_POINT })
            }
        },
    })
}
